export default __webpack_public_path__ + "static/partnerColorIcon15-d94dd8fc6208e7d4adf6308e4f33deb4.svg";